import $ from 'jquery';
import window from 'window';

function capitalize(value) {
    return value.toLowerCase().replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase(); });
}

$('[data-autodiscover-city]')
    .each(function () {
        const el = $(this);

        const target = $(el.attr('data-autodiscover-city'));

        if (!target) return this;

        let postCode;
        el.on('blur',
            function () {
                postCode = el.val();

                if (postCode.length === 0) return;

                $.getJSON('https://api.bring.com/shippingguide/api/postalCode.json?clientUrl=' +
                    window.location +
                    '&country=NO&pnr=' +
                    postCode,
                function (data) {
                    if (data.valid) {
                        target.each(function () {
                            $(this).val(capitalize(data.result));
                        });
                    }
                });
            });

        return this;
    });
